import { z } from 'zod';

/**
 * The shape of an `indskr_GetDeliveryScheduleBundle` payload as far as the schedule picker and the
 * delivery dates depend on it; see PRICING_BUNDLE_SCHEMA for what is and is not judged.
 */
const value = z.number().nullish();
const flag = z.boolean().nullish();

const deliverySchedule = z.looseObject({
  id: z.string(),
  name: z.string().nullish(),
  displayOrder: value,
  horizonMode: value,
  isAdhoc: flag,
  interval: value,
  periodType: value,
  dayOfWeek: value,
  anchorDay: value,
  defaultCount: value,
  horizonLength: value,
  horizonPeriodType: value,
  includePartialPeriod: flag,
  yearStartMonth: value,
  allowAddressOverride: flag,
});

export const DELIVERY_SCHEDULE_BUNDLE_SCHEMA = z.looseObject({
  deliverySchedules: z.array(deliverySchedule),
});
